import { SentenceApi } from '../api/SentenceApi';
import { editablePinyin } from '../component/studentInstructionalPinyin';

/** What a pinyin field opens with: the saved reading in tone numbers, so opening a form never changes it,
 * or a suggestion for text saved without one. */
export async function pinyinForEditing(text: string, saved?: string[] | null): Promise<string[]> {
    return saved?.length ? editablePinyin(saved).split(' ') : (await SentenceApi.getTextPinyin(text)).data.flat();
}
